import React, { useState } from 'react';
import { T, FONT, radius, type as ty, tint, alpha} from './poyais-ui/theme';
import { Card, Tile, Grid, Eyebrow, Button } from './poyais-ui/primitives';

const CONTENT_TYPES=[
  {key:'kategori',      label:'Kategori İçeriği',     icon:'📂', desc:'Kategori içeriklerinizi yazın.'},
  {key:'h1-meta',       label:'H1 ve Meta Description',icon:'🏷️', desc:'Web sitenizin H1 ve meta description tag\'lerini doldurun.'},
  {key:'google-ad',     label:'Google Ads',            icon:'🔍', desc:'Google Ads için reklam metinleri yazın.'},
  {key:'meta-ad',       label:'Meta Ads',              icon:'📘', desc:'Meta Ads için reklam metinleri yazın.'},
  {key:'product-desc',  label:'Ürün Açıklaması',       icon:'📦', desc:'E-Ticaret sitenizin ürün açıklamalarını yazın.'},
  {key:'social-post',   label:'Sosyal Medya',          icon:'📱', desc:'X, TikTok, LinkedIn içeriklerinizi yazın.'},
  {key:'email',         label:'E-Posta Oluşturun',     icon:'✉️',  desc:'Dilediğiniz konuda e-posta metinleri oluşturun.'},
  {key:'cta',           label:'CTA Metni',             icon:'🎯', desc:'Landing page mi tasarlıyorsunuz? Call to action metninizi hazırlayın.'},
];
const TONES=['Profesyonel','Samimi','Acil','Eğlenceli','Lüks','Güven Verici'];

interface Item{id:string;content:string;copied:boolean}
type View = 'home' | 'generate';

const AIMetinTab:React.FC<{config?:any;creditBalance?:number;onSpend?:()=>void}>=({creditBalance:creditBalanceProp=0})=>{
  const [view,setView]=useState<View>('home');
  const [ct,setCt]=useState('google-ad');
  const [tone,setTone]=useState('Profesyonel');
  const [brief,setBrief]=useState('');
  const [kw,setKw]=useState('');
  const [count,setCount]=useState(3);
  const [loading,setLoading]=useState(false);
  const [creditError,setCreditError]=useState('');
  const [results,setResults]=useState<Item[]>([]);

  const selectType=(key:string)=>{ setCt(key); setView('generate'); setResults([]); setBrief(''); };

  const generate=async()=>{
    if(!brief.trim())return;
    setCreditError('');
    setLoading(true);
    try{
      const token=localStorage.getItem('poyais_token')||localStorage.getItem('token');
      const clientId=parseInt(localStorage.getItem('poyais_active_client')||'1');
      const selected=CONTENT_TYPES.find(x=>x.key===ct)!;
      const systemPrompt=`Sen uzman bir dijital pazarlama içerik yazarısın. Türkiye pazarına yönelik, dönüşüm odaklı içerikler yazıyorsun. Sadece JSON formatında yanıt ver.`;
      const userPrompt=`${selected.label} için ${count} adet ${tone.toLowerCase()} tonda içerik yaz.\nBrief: ${brief}\nAnahtar Kelimeler: ${kw||'yok'}\n\nJSON: {"results":["içerik1","içerik2",...]}`;
      const res=await fetch('/api/v1/kreativ/metin/generate',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+token},body:JSON.stringify({system:systemPrompt,user:userPrompt,max_tokens:1500,client_id:clientId})});
      if(res.status===402){setCreditError('Krediniz yetersiz. Lütfen kredi yükleyin.');setLoading(false);return;}
      if(res.status===403){setCreditError('Bu özellik planınızda mevcut değil.');setLoading(false);return;}
      if(!res.ok)throw new Error();
      const data=await res.json();
      const raw=data.content||data.text||data.result||'';
      const jsonMatch=raw.match(/```json\s*([\s\S]*?)```/s)||raw.match(/\{[\s\S]*\}/);
      const clean=jsonMatch?jsonMatch[1]||jsonMatch[0]:raw;
      const parsed=JSON.parse(clean.trim());
      setResults((parsed.results as string[]).map((c,i)=>({id:`${Date.now()}-${i}`,content:c,copied:false})));
    }catch{
      setResults(Array.from({length:count},(_,i)=>({id:`demo-${i}`,copied:false,content:`[Seçenek ${i+1}] "${brief}" için ${tone.toLowerCase()} tonda içerik.`})));
    }finally{setLoading(false);}
  };

  const copy=(id:string,text:string)=>{
    navigator.clipboard.writeText(text);
    setResults(p=>p.map(r=>r.id===id?{...r,copied:true}:r));
    setTimeout(()=>setResults(p=>p.map(r=>r.id===id?{...r,copied:false}:r)),1500);
  };

  const CreditBadge=()=>(
    <div style={{display:'flex',justifyContent:'flex-end',padding:'12px 16px 0'}}>
      <div style={{display:'inline-flex',alignItems:'center',gap:10,background:tint(T.accent,8),border:`1px solid ${alpha(T.accent, 20)}`,borderRadius:radius.md,padding:'8px 16px'}}>
        <span style={{fontSize:11,color:T.accentDeep,fontWeight:600}}>KREDİ</span>
        <span style={{fontSize:15,fontWeight:800,color:T.accent,minWidth:20,textAlign:'center' as const}}>{creditBalanceProp}</span>
        <Button variant="soft" color={T.accent} onClick={()=>{ (window as any).__poyaisGoNav?.('kredi-yukle'); }}
          style={{padding:'4px 12px',fontSize:11}}>
          Kredi Yükle
        </Button>
      </div>
    </div>
  );

  if(view==='home') return(
    <div style={{fontFamily:FONT,minHeight:'100vh',background:T.surface}}>
      <style>{`@keyframes fadeIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}`}</style>
      <CreditBadge/>
      <div style={{padding:'32px 24px 20px',textAlign:'center' as const}}>
        <Eyebrow color={T.accent}>AI Metin Üretici</Eyebrow>
        <h2 style={{...ty.pageTitle,color:T.text,margin:'0 0 8px'}}>Ne yazmak istersiniz?</h2>
        <p style={{fontSize:13,color:T.textMid,margin:0}}>İçerik türünü seçin, brief girin, AI sizin için yazsın.</p>
      </div>
      <div style={{padding:'0 24px 32px'}}>
        <Grid min={220} gap={16} style={{maxWidth:1000,margin:'0 auto'}}>
          {CONTENT_TYPES.map(item=>(
            <Card key={item.key} hover onClick={()=>selectType(item.key)}
              style={{padding:'24px 20px',cursor:'pointer',textAlign:'left' as const,animation:'fadeIn 0.2s ease'}}>
              <div style={{fontSize:32,marginBottom:12}}>{item.icon}</div>
              <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:4}}>{item.label}</div>
              <div style={{fontSize:12,color:T.textMid,lineHeight:1.5}}>{item.desc}</div>
            </Card>
          ))}
        </Grid>
      </div>
    </div>
  );

  const selected=CONTENT_TYPES.find(x=>x.key===ct)!;
  return(
    <div style={{fontFamily:FONT,background:T.surface,minHeight:'100vh'}}>
      <style>{`@keyframes fadeIn{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}`}</style>
      <CreditBadge/>
      <div style={{padding:'12px 24px',borderBottom:`1px solid ${T.border}`,display:'flex',alignItems:'center',gap:12}}>
        <Button variant="soft" color={T.textMid} onClick={()=>setView('home')} style={{padding:'6px 14px',fontSize:12}}>
          ← Geri
        </Button>
        <span style={{fontSize:20}}>{selected.icon}</span>
        <div>
          <div style={{fontSize:14,fontWeight:700,color:T.text}}>{selected.label}</div>
          <div style={{fontSize:11,color:T.textMid}}>{selected.desc}</div>
        </div>
      </div>
      <div style={{padding:'20px 24px',display:'flex',flexDirection:'column' as const,gap:20}}>
        <div style={{display:'flex',flexDirection:'column' as const,gap:14}}>
          <Tile pad={16}>
            <div style={{...ty.label,color:T.textDim,marginBottom:10}}>TON</div>
            <div style={{display:'flex',flexWrap:'wrap' as const,gap:6}}>
              {TONES.map(t=>(
                <Button key={t} variant={tone===t?'soft':'ghost'} color={T.accent} onClick={()=>setTone(t)}
                  style={{padding:'5px 12px',fontSize:11,borderRadius:radius.pill}}>
                  {t}
                </Button>
              ))}
            </div>
          </Tile>
          <Tile pad={16} style={{background:T.surface,border:`1px solid ${alpha(T.accent, 15)}`}}>
            <div style={{...ty.label,color:T.textDim,marginBottom:8}}>BRİEF</div>
            <textarea value={brief} onChange={e=>setBrief(e.target.value)}
              placeholder="Ürün/hizmet, hedef kitle, öne çıkan özellikler…" rows={4}
              style={{width:'100%',background:T.card,border:`1px solid ${alpha(T.accent, 18)}`,borderRadius:7,color:T.text,fontSize:12,padding:'9px 12px',resize:'vertical' as const,outline:'none',fontFamily:'inherit',lineHeight:1.6,boxSizing:'border-box' as const}}
              onFocus={e=>e.target.style.borderColor=`${alpha(T.accent, 50)}`}
              onBlur={e=>e.target.style.borderColor=`${alpha(T.accent, 18)}`}/>
            <div style={{marginTop:10}}>
              <div style={{...ty.label,color:T.textDim,marginBottom:6}}>ANAHTAR KELİMELER</div>
              <input value={kw} onChange={e=>setKw(e.target.value)} placeholder="kelime1, kelime2, kelime3"
                style={{width:'100%',background:T.card,border:`1px solid ${alpha(T.accent, 18)}`,borderRadius:7,color:T.text,fontSize:12,padding:'9px 12px',outline:'none',boxSizing:'border-box' as const,fontFamily:'inherit'}}
                onFocus={e=>e.target.style.borderColor=`${alpha(T.accent, 50)}`}
                onBlur={e=>e.target.style.borderColor=`${alpha(T.accent, 18)}`}/>
            </div>
          </Tile>
          <Tile style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'12px 16px'}}>
            <span style={{fontSize:11,color:T.textMid,fontWeight:600}}>Metin Adedi</span>
            <div style={{display:'flex',alignItems:'center',gap:10}}>
              <span style={{fontSize:16,fontWeight:800,color:T.accent,minWidth:20,textAlign:'center' as const}}>{count}</span>
              <input type="range" min={1} max={5} value={count} onChange={e=>setCount(+e.target.value)} style={{width:80,accentColor:T.accent}}/>
            </div>
          </Tile>
          {creditError&&(
            <div style={{padding:'10px 12px',background:tint(T.red,8),border:`1px solid ${alpha(T.red, 25)}`,borderRadius:radius.sm,fontSize:11,color:T.redText}}>
              ⚠️ {creditError}
              <Button variant="ghost" color={T.accent} onClick={()=>(window as any).__poyaisGoNav?.('kredi-yukle')}
                style={{marginLeft:8,padding:0,border:'none',background:'none',color:T.accent,fontWeight:700,fontSize:11}}>
                Kredi Yükle →
              </Button>
            </div>
          )}
          <Button variant="solid" color={T.accent} disabled={loading||!brief.trim()} onClick={generate}
            style={{width:'100%',padding:'12px',fontSize:13,
              background:loading||!brief.trim()?T.card:`linear-gradient(135deg,${T.accent},${tint(T.accent,40)})`,
              color:loading||!brief.trim()?T.textMid:'#000000',
              cursor:loading||!brief.trim()?'not-allowed':'pointer',
              border:`1px solid ${loading?`${alpha(T.accent, 15)}`:T.accent}`}}>
            {loading?'Üretiliyor…':'Metinleri Üret'}
          </Button>
        </div>
        <div style={{width:'100%'}}>
          {results.length===0?(
            <Card style={{padding:'56px 20px',textAlign:'center' as const,background:T.card}}>
              <div style={{fontSize:40,marginBottom:12}}>{selected.icon}</div>
              <div style={{fontSize:15,fontWeight:700,color:T.text,marginBottom:6}}>{selected.label}</div>
              <div style={{fontSize:12,color:T.textMid}}>Brief'i doldurup "Metinleri Üret"'e bas.</div>
            </Card>
          ):(
            <div style={{display:'flex',flexDirection:'column' as const,gap:12}}>
              {results.map((item,idx)=>(
                <Card key={item.id} style={{padding:'16px 20px',border:`1px solid ${alpha(T.accent, 15)}`,animation:'fadeIn 0.2s ease'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                    <span style={{...ty.label,color:T.textDim}}>SEÇENEK {idx+1}</span>
                    <Button variant="soft" color={item.copied?T.green:T.accent} onClick={()=>copy(item.id,item.content)}
                      style={{padding:'4px 14px',fontSize:10}}>
                      {item.copied?'✓ Kopyalandı':'Kopyala'}
                    </Button>
                  </div>
                  <p style={{fontSize:13,color:T.text,lineHeight:1.75,margin:0,whiteSpace:'pre-wrap' as const}}>{item.content}</p>
                </Card>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AIMetinTab;
